
export class DriveItemResyncModel {
  driveId: string;
  listItemId: string;
  plannedDate: Date|null;
}
